const ProfileNameSpace = 'profile';

const ProfileActionTypes = Object.freeze({
    GetProfile: 'GetProfile',
    AddProfile: 'AddProfile',
    EditProfile: 'EditProfile',
});

const ProfileMutationTypes = Object.freeze({
    SetProfile: 'SetProfile',
});

const ProfileGetterTypes = Object.freeze({
    GetProfile: 'GetProfile',
});

export {
    ProfileNameSpace,
    ProfileActionTypes,
    ProfileMutationTypes,
    ProfileGetterTypes,
};